<template>
  <div class="pickup-form">
    <el-alert
      :title="$t('order.pickup.tipFee')"
      type="warning"
      show-icon
      :closable="false"
      style="margin-bottom: 8px"
    ></el-alert>
    <el-alert
      :title="$t('order.pickup.tipTimeWindow')"
      type="info"
      show-icon
      :closable="false"
      style="margin-bottom: 12px"
    ></el-alert>

    <div style="margin-bottom: 10px; text-align: right">
      <el-button type="primary" size="small" @click="reuseSenderInfo">
        {{ $t('order.pickup.reuseSender') }}
      </el-button>
    </div>

    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      size="small"
    >
      <!-- 取货源件 -->
      <el-row :gutter="10" class="border-col">
        <el-col :span="24">
          <div class="place-title">{{ $t('order.pickup.sourceInfo') }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item :label="$t('order.pickup.labelName')" prop="q_data.realname">
            <el-input
              v-model="ruleForm.q_data.realname"
              :placeholder="$t('order.pickup.placeholderName')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.pickup.labelCompany')" prop="q_data.company">
            <el-input
              v-model="ruleForm.q_data.company"
              :placeholder="$t('order.pickup.placeholderCompany')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.pickup.labelCountry')" prop="q_data.country">
            <el-select
              filterable
              v-model="ruleForm.q_data.country"
              :placeholder="$t('order.pickup.placeholderCountry')"
              style="width: 100%"
              @change="handleCountryChange"
            >
              <el-option
                v-for="(item, index) in countryList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.pickup.labelProvince')" prop="q_data.province">
            <el-select
              filterable
              v-model="ruleForm.q_data.province"
              :placeholder="$t('order.pickup.placeholderProvince')"
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in provinceList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item :label="$t('order.pickup.labelCity')" prop="q_data.city">
            <el-input
              v-model="ruleForm.q_data.city"
              :placeholder="$t('order.pickup.placeholderCity')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.pickup.labelZcode')" prop="q_data.zcode">
            <el-input
              v-model="ruleForm.q_data.zcode"
              :placeholder="$t('order.pickup.placeholderZcode')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.pickup.labelAddress1')" prop="q_data.address_one">
            <el-input
              v-model="ruleForm.q_data.address_one"
              :placeholder="$t('order.pickup.placeholderAddress1')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.pickup.labelAddress2')" prop="q_data.address_two">
            <el-input
              v-model="ruleForm.q_data.address_two"
              :placeholder="$t('order.pickup.placeholderAddress2')"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item :label="$t('order.pickup.labelMobile')" prop="q_data.mobile">
            <el-input
              v-model="ruleForm.q_data.mobile"
              :placeholder="$t('order.pickup.placeholderMobile')"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 包裹信息 -->
      <el-row :gutter="10" class="border-col">
        <el-col :span="24">
          <div class="place-title">{{ $t('order.pickup.packageInfo') }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item :label="$t('order.pickup.labelTotalPackages')" prop="q_package.package_all_num">
            <el-input
              v-model="ruleForm.q_package.package_all_num"
              :placeholder="$t('order.pickup.placeholderTotalPackages')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.pickup.labelTotalWeight')" prop="q_package.all_weight">
            <el-input
              v-model="ruleForm.q_package.all_weight"
              :placeholder="$t('order.pickup.placeholderTotalWeight')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.pickup.labelPickupDate')" prop="q_package.q_date">
            <el-date-picker
              v-model="ruleForm.q_package.q_date"
              type="date"
              value-format="yyyy-MM-dd"
              style="width: 100%"
              :placeholder="$t('order.pickup.placeholderPickupDate')"
              :picker-options="pickupDatePickerOptions"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.pickup.labelReadyTime')" prop="q_package.q_time">
            <el-select
              v-model="ruleForm.q_package.q_time"
              :placeholder="$t('order.pickup.placeholderReadyTime')"
              style="width: 100%"
              @change="changeReadyTime"
            >
              <el-option
                v-for="(item, index) in qtimelist"
                :key="index"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item :label="$t('order.pickup.labelLatestTime')" prop="q_package.q_endtime">
            <el-select
              v-model="ruleForm.q_package.q_endtime"
              :placeholder="$t('order.pickup.placeholderLatestTime')"
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in qendtimelist"
                :key="index"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="18">
          <el-form-item :label="$t('order.pickup.labelRemark')" prop="q_package.package_remark">
            <el-input
              type="textarea"
              :rows="2"
              v-model="ruleForm.q_package.package_remark"
              :placeholder="$t('order.pickup.placeholderRemark')"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 历史记录 -->
      <el-row :gutter="10" v-if="history.length" class="border-col">
        <el-col :span="24">
          <div class="place-title">{{ $t('order.pickup.historyTitle') }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="10" v-if="history.length">
        <el-col :span="24">
          <el-table :data="history" border size="mini" max-height="180">
            <el-table-column prop="create_time" :label="$t('order.pickup.colDate')" width="160"></el-table-column>
            <el-table-column :label="$t('order.pickup.colPRN')" width="180">
              <template slot-scope="scope">
                {{ (scope.row.pickup_location || '') + (scope.row.pickup_confirmation || '') }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('order.pickup.colStatus')" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.status == 1" style="color: #67c23a">{{ $t('order.pickup.statusBooked') }}</span>
                <span v-else style="color: #f56c6c">{{ $t('order.pickup.statusFailed') }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="pickup_money" :label="$t('order.pickup.colMoney')" width="80">
              <template slot-scope="scope">${{ scope.row.pickup_money }}</template>
            </el-table-column>
            <el-table-column prop="error_msg" :label="$t('order.pickup.colMsg')" show-overflow-tooltip></el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-form>

    <div style="text-align: right; margin-top: 20px">
      <el-button @click="$emit('close')">{{ $t('order.pickup.cancel') }}</el-button>
      <el-button type="primary" :loading="submitting" @click="handleSubmit">
        {{ $t('order.pickup.submit') }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { City } from '@/api/common';
import { pickupOrder, pickupSenderInfo, pickupHistory } from '@/api/order';
import {
  transformCountryCity,
  provinceListValue,
  findTimeIndex,
  formatPickupDateValue,
  getPickupNowMinutes,
  getPickupTodayValue,
  getPickupTimeZone,
  isPickupDateBeforeToday,
  parsePickupTimeToMinutes,
} from '@/common/common.js';

export default {
  props: {
    orderId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      submitting: false,
      countryList: [],
      provinceList: [],
      countryRaw: [],
      qtimelist: [
        '7:00 am', '7:30 am', '8:00 am', '8:30 am', '9:00 am', '9:30 am',
        '10:00 am', '10:30 am', '11:00 am', '11:30 am', '12:00 pm', '12:30 pm',
        '1:00 pm', '1:30 pm', '2:00 pm', '2:30 pm', '3:00 pm', '3:30 pm',
        '4:00 pm', '4:30 pm', '5:00 pm', '5:30 pm', '6:00 pm', '6:30 pm',
        '7:00 pm', '7:30 pm', '8:00 pm', '8:30 pm', '9:00 pm',
      ],
      qendtimelist: [],
      senderInfo: {},
      history: [],
      ruleForm: {
        q_data: {
          realname: '',
          company: '',
          country: '',
          province: '',
          city: '',
          zcode: '',
          address_one: '',
          address_two: '',
          mobile: '',
        },
        q_package: {
          package_all_num: '',
          all_weight: '',
          q_date: '',
          q_time: '9:00 am',
          q_endtime: '5:00 pm',
          package_remark: '',
        },
      },
      rules: {
        'q_data.realname':    [{ required: true, message: this.$t('order.pickup.placeholderName'), trigger: 'blur' }],
        'q_data.country':     [{ required: true, message: this.$t('order.pickup.placeholderCountry'), trigger: 'change' }],
        'q_data.province':    [{ required: true, message: this.$t('order.pickup.placeholderProvince'), trigger: 'change' }],
        'q_data.city':        [{ required: true, message: this.$t('order.pickup.placeholderCity'), trigger: 'blur' }],
        'q_data.zcode':       [{ required: true, message: this.$t('order.pickup.placeholderZcode'), trigger: 'blur' }],
        'q_data.address_one': [{ required: true, message: this.$t('order.pickup.placeholderAddress1'), trigger: 'blur' }],
        'q_data.mobile':      [{ required: true, message: this.$t('order.pickup.placeholderMobile'), trigger: 'blur' }],
        'q_package.package_all_num': [{ required: true, message: this.$t('order.pickup.placeholderTotalPackages'), trigger: 'blur' }],
        'q_package.all_weight':      [{ required: true, message: this.$t('order.pickup.placeholderTotalWeight'), trigger: 'blur' }],
        'q_package.q_date':          [{ required: true, message: this.$t('order.pickup.placeholderPickupDate'), trigger: 'change' }],
        'q_package.q_time':          [{ required: true, message: this.$t('order.pickup.placeholderReadyTime'), trigger: 'change' }],
        'q_package.q_endtime':       [{ required: true, message: this.$t('order.pickup.placeholderLatestTime'), trigger: 'change' }],
      },
    };
  },
  created() {
    this.getCity();
    // 默认 ready=9:00 am 时，先把对应的 endtime 列表初始化
    this.qendtimelist = findTimeIndex(this.qtimelist, this.ruleForm.q_package.q_time);
    this.loadDefaults();
    this.loadHistory();
  },
  computed: {
    pickupDatePickerOptions() {
      return {
        disabledDate: (time) => isPickupDateBeforeToday(
          time,
          this.ruleForm.q_data.country,
          this.ruleForm.q_data.province,
        ),
      };
    },
  },
  methods: {
    getCity() {
      City().then((res) => {
        this.countryRaw = res.data || [];
        this.countryList = transformCountryCity(this.countryRaw);
      });
    },
    loadDefaults() {
      pickupSenderInfo({
        user_code: JSON.parse(window.localStorage.getItem('userInfo1')).user_code,
        order_id: this.orderId,
      }).then((res) => {
        if (res.code != 1) {
          this.$message.error(res.msg);
          return;
        }
        this.senderInfo = res.data.send_data || {};
        const p = res.data.q_package || {};
        // 一律用发件人信息默认填入取货源件（与“复用发件人信息”按钮同一份数据，字段同名直拷）
        const sender = this.senderInfo || {};
        Object.keys(this.ruleForm.q_data).forEach((k) => {
          if (sender[k] !== undefined && sender[k] !== null) {
            this.ruleForm.q_data[k] = sender[k];
          }
        });
        // 默认带入包裹数与重量
        if (p.package_all_num) this.ruleForm.q_package.package_all_num = p.package_all_num;
        if (p.all_weight) this.ruleForm.q_package.all_weight = p.all_weight;
        if (p.q_date) this.ruleForm.q_package.q_date = formatPickupDateValue(p.q_date);
        if (p.q_time) {
          this.ruleForm.q_package.q_time = p.q_time;
          this.qendtimelist = findTimeIndex(this.qtimelist, p.q_time);
        }
        if (p.q_endtime) this.ruleForm.q_package.q_endtime = p.q_endtime;
        if (p.package_remark) this.ruleForm.q_package.package_remark = p.package_remark;

        if (this.ruleForm.q_data.country) {
          this.refreshProvinceList(this.ruleForm.q_data.country);
        }
      });
    },
    loadHistory() {
      pickupHistory({
        user_code: JSON.parse(window.localStorage.getItem('userInfo1')).user_code,
        order_id: this.orderId,
      }).then((res) => {
        if (res.code == 1 && res.data && res.data.list) {
          this.history = res.data.list;
        }
      });
    },
    refreshProvinceList(country) {
      this.provinceList = provinceListValue(this.countryList, country).map((item) => ({
        label: item.label,
        value: item.label,
      }));
    },
    handleCountryChange(val) {
      this.ruleForm.q_data.province = '';
      this.refreshProvinceList(val);
    },
    changeReadyTime(val) {
      this.qendtimelist = findTimeIndex(this.qtimelist, val);
      this.ruleForm.q_package.q_endtime = '';
    },
    reuseSenderInfo() {
      const s = this.senderInfo || {};
      Object.keys(this.ruleForm.q_data).forEach((k) => {
        if (s[k] !== undefined && s[k] !== null) {
          this.ruleForm.q_data[k] = s[k];
        }
      });
      if (this.ruleForm.q_data.country) {
        this.refreshProvinceList(this.ruleForm.q_data.country);
      }
    },
    /**
     * 校验取件时间窗
     *  - close 必须晚于 ready 至少 2 小时（承运商最低要求）
     *  - close 不能早于 12:00 pm（避免半天就让司机来）
     *  - 如果取件日期是今天，ready time 必须在当前时间之后至少 2 小时
     */
    checkTimeWindow(ready, close) {
      if (!ready || !close) return { ok: true };
      const r = parsePickupTimeToMinutes(ready);
      const c = parsePickupTimeToMinutes(close);
      if (r === null || c === null) return { ok: true };
      if (c - r < 120) {
        return {
          ok: false,
          msg: this.$t('order.pickup.errWindowTooShort'),
        };
      }
      if (c < 12 * 60) {
        return {
          ok: false,
          msg: this.$t('order.pickup.errCloseTooEarly'),
        };
      }
      // 如果取件日期是今天，ready time 必须在当前时间之后至少 2 小时
      const pickupDate = formatPickupDateValue(this.ruleForm.q_package.q_date);
      if (pickupDate) {
        const todayStr = getPickupTodayValue(this.ruleForm.q_data.country, this.ruleForm.q_data.province);
        if (pickupDate === todayStr) {
          const nowMinutes = getPickupNowMinutes(this.ruleForm.q_data.country, this.ruleForm.q_data.province);
          if (r < nowMinutes + 120) {
            return {
              ok: false,
              msg: this.$t('order.pickup.errTodayTooLate'),
            };
          }
        }
      }
      return { ok: true };
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        this.ruleForm.q_package.q_date = formatPickupDateValue(this.ruleForm.q_package.q_date);
        // 时间窗校验：close - ready 至少 2 小时，且 close 不能早于 12:00 pm
        const tw = this.checkTimeWindow(this.ruleForm.q_package.q_time, this.ruleForm.q_package.q_endtime);
        if (!tw.ok) {
          this.$message.error(tw.msg);
          return;
        }
        this.$confirm(this.$t('order.pickup.confirmContent'), this.$t('order.pickup.confirmTitle'), {
          type: 'warning',
        })
          .then(() => {
            this.submitting = true;
            pickupOrder({
              user_code: JSON.parse(window.localStorage.getItem('userInfo1')).user_code,
              order_id: this.orderId,
              q_data: this.ruleForm.q_data,
              q_package: {
                ...this.ruleForm.q_package,
                pickup_timezone: getPickupTimeZone(this.ruleForm.q_data.country, this.ruleForm.q_data.province),
              },
            })
              .then((res) => {
                this.submitting = false;
                if (res.code == 1) {
                  this.$message.success(res.msg || this.$t('order.pickup.success'));
                  this.$emit('success', res.data);
                } else {
                  this.$message.error(res.msg);
                  this.loadHistory();
                }
              })
              .catch((err) => {
                this.submitting = false;
                if (err && err.msg) {
                  this.$message.error(err.msg);
                }
                this.loadHistory();
              });
          })
          .catch(() => {});
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.pickup-form {
  .border-col {
    margin: 10px 0 5px 0;
    padding: 6px 0;
    border-bottom: 1px solid #ebeef5;
  }
  .place-title {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
  }
}
</style>
